export enum SnackbarType {
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
}

export enum SnackbarPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export interface ISnackbarProps {
  summary?: string;
  message: string;
  position?: SnackbarPosition;
  variant?: SnackbarType;
  autoHideDuration?: number;
}
